import { TypedObjNode } from "./_Base";
import { Group } from "three";
import { DisplayNodeController } from "../utils/DisplayNodeController";
import { NodeContext } from "../../poly/NodeContext";
import { TransformedParamConfig, TransformController } from "./utils/TransformController";
import { FlagsControllerD } from "../utils/FlagsController";
import { HierarchyController } from "./utils/HierarchyController";
import { NodeParamsConfig, ParamConfig } from "../utils/params/ParamsConfig";
import { ChildrenDisplayController } from "./utils/ChildrenDisplayController";
import { isBooleanTrue } from "../../../core/BooleanValue";
import { ObjType } from "../../poly/registers/nodes/types/Obj";
class GeoObjParamConfig extends TransformedParamConfig(NodeParamsConfig) {
  constructor() {
    super(...arguments);
    this.display = ParamConfig.BOOLEAN(1);
    this.renderOrder = ParamConfig.INTEGER(0, {
      range: [0, 10],
      rangeLocked: [true, false]
    });
  }
}
const ParamsConfig = new GeoObjParamConfig();
export class GeoObjNode extends TypedObjNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
    this.hierarchyController = new HierarchyController(this);
    this.transformController = new TransformController(this);
    this.flags = new FlagsControllerD(this);
    this.childrenDisplayController = new ChildrenDisplayController(this);
    this.displayNodeController = new DisplayNodeController(this, this.childrenDisplayController.displayNodeControllerCallbacks());
    this._childrenControllerContext = NodeContext.SOP;
    this._onChildAddBound = this._onChildAdd.bind(this);
  }
  static type() {
    return ObjType.GEO;
  }
  createObject() {
    const group = new Group();
    group.matrixAutoUpdate = false;
    return group;
  }
  initializeNode() {
    this.lifecycle.onChildAdd(this._onChildAddBound);
    this.hierarchyController.initializeNode();
    this.transformController.initializeNode();
    this.childrenDisplayController.initializeNode();
  }
  isDisplayNodeCooking() {
    if (this.flags.display.active()) {
      const display_node = this.displayNodeController.displayNode();
      return display_node ? display_node.isDirty() : false;
    } else {
      return false;
    }
  }
  createNode(node_class, options) {
    return super.createNode(node_class, options);
  }
  children() {
    return super.children();
  }
  nodesByType(type) {
    return super.nodesByType(type);
  }
  _onChildAdd(node) {
    var _a, _b;
    if (this.scene().loadingController.loaded()) {
      if (this.children().length == 1) {
        (_b = (_a = node.flags) == null ? void 0 : _a.display) == null ? void 0 : _b.set(true);
      }
    }
  }
  cook() {
    this.transformController.update();
    this.object.visible = isBooleanTrue(this.pv.display);
    this.object.renderOrder = this.pv.renderOrder;
    this.cookController.endCook();
  }
}
